"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
const _excluded = ["abi", "address", "args", "functionName"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readContract = void 0;
const decodeFunctionResult_js_1 = require("../../utils/abi/decodeFunctionResult.js");
const encodeFunctionData_js_1 = require("../../utils/abi/encodeFunctionData.js");
const getContractError_js_1 = require("../../utils/errors/getContractError.js");
const getAction_js_1 = require("../../utils/getAction.js");
const call_js_1 = require("./call.js");
async function readContract(client, _ref) {
  let {
      abi,
      address,
      args,
      functionName
    } = _ref,
    callRequest = _objectWithoutProperties(_ref, _excluded);
  const calldata = (0, encodeFunctionData_js_1.encodeFunctionData)({
    abi,
    args,
    functionName
  });
  try {
    const {
      data
    } = await (0, getAction_js_1.getAction)(client, call_js_1.call, 'call')(_objectSpread({
      data: calldata,
      to: address
    }, callRequest));
    return (0, decodeFunctionResult_js_1.decodeFunctionResult)({
      abi,
      args,
      functionName,
      data: data || '0x'
    });
  } catch (err) {
    throw (0, getContractError_js_1.getContractError)(err, {
      abi: abi,
      address,
      args,
      docsPath: '/docs/contract/readContract',
      functionName
    });
  }
}
exports.readContract = readContract;
//# sourceMappingURL=readContract.js.map